<template>
  <v-container fluid>
    <div>
      <component
        :is="isCompo"
        type="Admission"
        :enquiryID="newAdmissionID"
        :STUDENT_DATA="STUDENT_DATA"
      >
      </component>
    </div>

    <material-card icon="mdi-trending-up" inline title="Promotion SIS list">
      <v-card outlined>
        <v-toolbar color="primary" dark>
          <v-tabs v-model="tab" absolute top right>
            <v-tab class="font-weight-bold">Yet to Promoted</v-tab>
            <v-tab class="font-weight-bold"
              >Assign Fee for Promoted Student</v-tab
            >
          </v-tabs>
        </v-toolbar>
        <v-card flat class="px-4">
          <v-row>
            <v-col cols="12" md="6" lg="4">
              <div v-if="tab === 0">
                <label class="font-weight-medium body-2">Select Class</label>
                <v-autocomplete
                  key="id"
                  class="my-0 py-1"
                  v-model="selectedClassID"
                  placeholder="Select Class"
                  menu-props="auto"
                  :items="classes"
                  @change="changeSections()"
                  single-line
                  item-text="name"
                  item-value="id"
                >
                </v-autocomplete>
              </div>
              <div v-if="tab === 1">
                <label class="font-weight-medium body-2">Select Class</label>
                <v-autocomplete
                  class="my-0 py-1"
                  key="id"
                  v-model="selectedClassID"
                  placeholder="Select Class"
                  menu-props="auto"
                  :items="classes"
                  @change="getPromotedStudentList()"
                  single-line
                  item-text="name"
                  item-value="id"
                >
                </v-autocomplete>
              </div>
            </v-col>

            <v-col cols="12" md="6" lg="4">
              <div v-if="tab === 0">
                <label class="font-weight-medium body-2">Select Section</label>
                <v-autocomplete
                  key="id"
                  v-model="selectedSectionID"
                  menu-props="auto"
                  single-line
                  :items="classWiseSections"
                  @change="
                    getStudents(
                      franchiseeID,
                      selectedClassID,
                      selectedSectionID,
                      academicYearID
                    )
                  "
                  item-text="name"
                  item-value="id"
                  class="my-0 py-1"
                  placeholder="Select Section"
                >
                </v-autocomplete>
              </div>
              <div v-if="tab === 1">
                <label class="font-weight-medium body-2">Select Section</label>
                <v-autocomplete
                  key="id"
                  v-model="selectedSectionID"
                  menu-props="auto"
                  single-line
                  class="my-0 py-1"
                  :items="classWiseSections"
                  @change="getPromotedStudentList()"
                  item-text="name"
                  item-value="id"
                  placeholder="Select Section"
                >
                </v-autocomplete>
              </div>
            </v-col>
          </v-row>
        </v-card>
        <v-divider class="my-0"></v-divider>
        <v-card flat class="pa-4">
          <template v-if="tab === 0">
            <!-- <v-toolbar flat color="white">
              <v-toolbar-title>Yet to Promoted</v-toolbar-title>
            </v-toolbar> -->
            <v-card-text
              class="pt-0 pr-1"
              :class="{
                'd-block py-3': $vuetify.breakpoint.xs,
                'd-flex align-center': $vuetify.breakpoint.smAndUp
              }"
            >
              <v-card-title>
                Yet to Promoted
                <v-spacer></v-spacer>
              </v-card-title>
              <v-text-field
                :class="{
                  'mr-0': $vuetify.breakpoint.xs,
                  'mr-5': $vuetify.breakpoint.smAndUp
                }"
                v-model="search"
                append-icon="mdi-magnify"
                class="ml-auto mb-2"
                label="Search"
                hide-details
                single-line
                style="max-width: 350px"
              />
            </v-card-text>
            <v-divider class="my-0 py-0"></v-divider>
            <v-data-table
              :search="search"
              :item-class="itemRowBackground"
              :headers="headers"
              :items="students"
              :footer-props="{
                'items-per-page-options': [5, 10, 20, 40]
              }"
            >
              <template v-slot:item.promotedType="{ item }">
                <v-autocomplete
                  :disabled="getDisabled(item)"
                  key="id"
                  @change="getPromotedByType(item)"
                  v-model="item.selectedInfo.promotedTypeID"
                  menu-props="auto"
                  label="To Type"
                  single-line
                  :items="item.promotionType"
                  item-text="label"
                  item-value="id"
                ></v-autocomplete>
              </template>
              <!--v-if="item.selectedInfo.promotedTypeID == 1 || item.selectedInfo.promotedTypeID == 5 || item.selectedInfo.promotedTypeID === ''"-->
              <template v-slot:item.promotedClass="{ item }">
                <div
                  v-if="
                    item.selectedInfo.promotedTypeID == 2 ||
                    item.selectedInfo.promotedTypeID == 1 ||
                    item.selectedInfo.promotedTypeID == 5 ||
                    item.selectedInfo.promotedTypeID === ''
                  "
                >
                  <v-autocomplete
                    required
                    :disabled="getDisabled(item)"
                    key="id"
                    v-model="item.selectedInfo.selectedClass"
                    @change="getPromotedSection(item)"
                    menu-props="auto"
                    label=" To Class"
                    single-line
                    :items="item.classSectionMaps"
                    item-text="name"
                    item-value="id"
                  >
                  </v-autocomplete>
                </div>
                <div v-else-if="item.selectedInfo.promotedTypeID === 2">
                  {{ item.studentClass.name }}
                  <!-- <v-autocomplete
              key="id"
              :value="(item.selectedInfo.selectedClass = item.studentClass.id)"
              @change="getPromotedSection(item)"
              menu-props="auto"
              label=" To Class"
              single-line
              :items="item.classSectionMaps"
              item-text="name"
              item-value="id"
            >
            </v-autocomplete> -->
                </div>
              </template>

              <template v-slot:item.action="{ item }">
                <!-- My {{ item && item.studentPromoteStatus && item.studentPromoteStatus.newStudentAdmissionsID ? item.studentPromoteStatus.newStudentAdmissionsID : '' }} -->
                <div
                  v-if="
                    item.selectedInfo.promotedTypeID === 3 &&
                    !(
                      item &&
                      item.studentPromoteStatus &&
                      item.studentPromoteStatus.promotedTypeID === 3
                    )
                  "
                >
                  <v-btn
                    @click="promoteStudent(item)"
                    depressed
                    class="px-2 ml-1 ma-1"
                    min-width="0"
                    small
                    color="primary"
                  >
                    Save
                  </v-btn>
                </div>

                <div
                  v-else-if="
                    item &&
                    item.studentPromoteStatus &&
                    item.studentPromoteStatus.newStudentAdmissionsID &&
                    //item.isAdmissionConfirmed === 'confirmed'
                    item.isPromoted === 'confirmed'
                  "
                >
                  <v-btn
                    class="px-2 ml-1 ma-1"
                    min-width="0"
                    outlined
                    small
                    color="warning"
                  >
                    Already Promoted
                  </v-btn>
                </div>

                <div
                  v-else-if="
                    item &&
                    item.studentPromoteStatus &&
                    item.studentPromoteStatus.newStudentAdmissionsID &&
                    //item.isAdmissionConfirmed !== 'confirmed'
                    ( item.isPromoted == 'pendingForPromotion' || item.isPromoted == 'pendingForAssignOrder' || item.isPromoted == 'pendingForBBPayment')
                  "
                >
                  <v-btn
                    class="px-2 ml-1 ma-1"
                    min-width="0"
                    outlined
                    small
                    color="warning"
                  >
                    PROMOTION PENDING FOR BRAINBEES PAYMENT

                  </v-btn>
                </div>

                <div v-else-if="item &&
                  item.studentPromoteStatus &&
                  item.studentPromoteStatus.promotedTypeID === 3
                  ? true
                  : false
                  ">
                  <v-btn class="px-2 ml-1 ma-1" min-width="0" outlined small color="error">
                    Already Dropped
                  </v-btn>
                </div>

                <div v-else>
                  <v-btn
                    class="px-2 ml-1 ma-1"
                    min-width="0"
                    depressed
                    outlined
                    :disabled="getDisabled(item)"
                    @click="promoteStudent(item)"
                    small
                    color="accent"
                  >
                    Promote
                  </v-btn>
                </div>
              </template>

              <template v-slot:item.promotedSection="{ item }">
                <div
                  v-if="
                    !(
                      item.selectedInfo.promotedTypeID === 3 ||
                      item.selectedInfo.promotedTypeID === 4
                    )
                  "
                >
                  <v-autocomplete
                    required
                    :disabled="
                      (Number(item.studentEnrollment.amountDue) > 0
                        ? true
                        : false) ||
                      (item &&
                      item.studentPromoteStatus &&
                      item.studentPromoteStatus.newStudentAdmissionsID
                        ? true
                        : false) ||
                      (item &&
                        item.studentPromoteStatus &&
                        item.studentPromoteStatus.promotedTypeID === 3)
                    "
                    key="id"
                    v-model="item.selectedInfo.selectedSection"
                    menu-props="auto"
                    label="To Section"
                    single-line
                    :items="item.selectedSectionMap"
                    item-text="name"
                    item-value="id"
                  >
                  </v-autocomplete>
                </div>
              </template>

              <template v-slot:item.date="{ item }">
                <div v-if="item.selectedInfo.promotedTypeID !== 3">
                  <custom-date-picker
                    :disabled="getDisabled(item)"
                    header-color="green lighten-1"
                    color="green lighten-1"
                    v-model="item.selectedInfo.expectedDate"
                    required
                  />
                </div>
              </template>
              <template v-slot:top>
                <v-dialog v-model="dialogDelete" max-width="450px">
                  <v-card>
                    <v-card-title class="warning"> Warning </v-card-title><br />

                    <p class="pl-3" v-if="promotedTypeID === 3">
                      Are you sure, do you want to drop this student?
                    </p>
                    <p class="pl-3" v-else>
                      Are you sure, do you want to promote this student to
                    </p>
                    <center>
                      <p style="font-size: 18px">
                        <b v-if="selectedClassName">
                          {{ selectedClassName.name }}
                        </b>
                      </p>
                    </center>
                    <p class="pl-3">
                      Once you click on OK changes cannot be done later.
                    </p>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        color="blue darken-1"
                        text
                        @click="dialogDelete = false"
                        >Cancel</v-btn
                      >
                      <v-btn color="blue darken-1" @click="givenOkay" text
                        >OK</v-btn
                      >
                      <v-spacer></v-spacer>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </template>
              <template v-slot:no-data>
                <v-card-subtitle class="d-flex justify-center"
                  >No Data Available</v-card-subtitle
                >
              </template>
            </v-data-table>
          </template>
          <template v-if="tab === 1">
            <!-- <v-toolbar flat color="white">
              <v-toolbar-title></v-toolbar-title>
            </v-toolbar> -->

            <v-card-text
              class="pt-0 pr-1"
              :class="{
                'd-block py-3': $vuetify.breakpoint.xs,
                'd-flex align-center': $vuetify.breakpoint.smAndUp
              }"
            >
              <v-card-title>
                Assign Fee Plan
                <v-spacer></v-spacer>
              </v-card-title>
              <v-text-field
                :class="{
                  'mr-0': $vuetify.breakpoint.xs,
                  'mr-5': $vuetify.breakpoint.smAndUp
                }"
                v-model="search"
                append-icon="mdi-magnify"
                class="ml-auto mb-2"
                label="Search"
                hide-details
                single-line
                style="max-width: 350px"
              />
              <v-btn @click="getPromotedStudentList()">
                <v-icon left> mdi-refresh </v-icon>
                Refresh
              </v-btn>
            </v-card-text>
            <v-divider class="my-0 py-0"></v-divider>
            <v-data-table
              :search="search"
              :headers="feeAssignHeader"
              :items="assignfeePlanInfo"
              sort-by
              hide-default-footer
              :items-per-page="-1"
            >
              <template v-slot:item.action="{ item }">
                <v-btn
                  class="px-2 ml-1 ma-1"
                  min-width="0"
                  v-if="item.newStudentAdmission && item.newStudentAdmission.id"
                  @click="assignFee(item)"
                  outlined
                  small
                  depressed
                  color="green"
                >
                  Assign Fee
                </v-btn>
                <v-btn
                  v-if="showRevoke(item)"
                  class="px-2 ml-1 ma-1"
                  min-width="0"
                  depressed
                  outlined
                  small
                  color="error"
                  @click="openRevokeDialog(item)"
                >
                  Revoke
                </v-btn>
                <!-- <v-btn
                  class="px-2 ml-1 ma-1"
                  min-width="0"
                  v-if="item.newStudentAdmission.id && item.newStudentAdmission.isAdmissionConfirmed == 'pending'"
                  depressed
                  @click="assignOrder(item.newStudentAdmission.id)"
                  outlined
                  small
                  color="primary"
                >
                  Assign Order
                </v-btn> -->
                <v-btn
                  class="px-2 ml-1 ma-1"
                  min-width="0"
                  v-if="item.assignFeeComponentActivesID"
                  depressed
                  @click="sendLink(item, true)"
                  outlined
                  small
                  color="primary"
                >
                  Offline Payment
                </v-btn>
                <v-tooltip bottom :disabled="!isRazorPayAccount" color="black">
                  <template v-slot:activator="{ on }">
                    <div v-on="on" class="d-inline-block">
                      <v-btn
                        class="px-2 ml-1 ma-1"
                        min-width="0"
                        v-if="item.assignFeeComponentActivesID"
                        @click="sendLink(item)"
                        depressed
                        outlined
                        small
                        color="green"
                        v-tooltip="{ content: 'Tooltip Content' }"
                        :disabled="isRazorPayAccount"
                      >
                        Send Link
                      </v-btn>
                    </div>
                  </template>
                  <span
                    >You have to open Razorpay account for online payment.
                  </span>
                </v-tooltip>
                <v-btn
                  class="px-2 ml-1 ma-1"
                  min-width="0"
                  v-if="item.oldStudentAdmission && item.oldStudentAdmission.id && item.oldStudentAdmission.isPromoted == 'pendingForAssignOrder'"
                  depressed
                  @click="assignOrder(item.newStudentAdmission.id)"
                  outlined
                  small
                  color="primary"
                >
                  Assign Order
                </v-btn>

                <p>
                  <a v-if="item.oldStudentAdmission && item.oldStudentAdmission.isPromoted == 'pendingForBBPayment'" href="/payments/transfer-franchiseeToBB" target="_blank" class="fontBold" >
                    Pay Amount to BrainBees
                  </a>
                </p>

              </template>
              <template v-slot:item.studentPromoteType.name="{ item }">
                <span
                  v-if="
                    item.studentPromoteType.name === 'DETAINED_AND_PROMOTED'
                  "
                >
                  RETAIN
                </span>
                <span v-else>
                  {{ item.studentPromoteType.name }}
                </span>
              </template>
              <template v-slot:item.class="{ item }">
                <span>
                  {{
                    item.newStudentAdmission
                      ? item.newStudentAdmission.class
                      : '-'
                  }}
                </span>
              </template>
              <template v-slot:item.section="{ item }">
                <span>
                  {{
                    item.newStudentAdmission
                      ? item.newStudentAdmission.section
                      : '-'
                  }}
                </span>
              </template>
              <template v-slot:item.name="{ item }">
                <span>
                  {{
                    item.newStudentAdmission
                      ? item.newStudentAdmission.studentEnrollment.studentName
                      : item.oldStudentAdmission.studentEnrollment.studentName
                  }}
                </span>
              </template>
              <template v-slot:item.enrol="{ item }">
                <span>
                  {{
                    item.newStudentAdmission
                      ? item.newStudentAdmission.studentEnrollment
                          .enrollmentCode
                      : item.oldStudentAdmission.studentEnrollment
                          .enrollmentCode
                  }}
                </span>
              </template>
              <template v-slot:item.year="{ item }">
                <span>
                  {{
                    item.newStudentAdmission
                      ? item.newStudentAdmission.franchiseeAcademicYear
                          .academicYear
                      : item.oldStudentAdmission.franchiseeAcademicYear
                          .academicYear
                  }}
                </span>
              </template>
              <template v-slot:no-data>
                <v-card-subtitle class="d-flex justify-center"
                  >No Data Available</v-card-subtitle
                >
              </template>
            </v-data-table>
          </template>
        </v-card>
      </v-card>
    </material-card>
    <v-dialog v-model="revokeDialog" max-width="450px">
      <v-card>
        <v-card-title class="warning">Revoke Promotion</v-card-title>
        <v-card-text>
          <p>
            You have promoted this student from
            <b>{{ revokeData.newClass }}</b> to <b>{{ revokeData.oldClass }}</b>.<br>
            Do you want to revoke this promotion?
          </p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" text @click="revokePromotion(revokeData)">Yes, Revoke</v-btn>
          <v-btn color="primary" text @click="revokeDialog = false">Cancel</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <loading-icon :value="isLoading" />
  </v-container>
</template>
<script>
import constants from '@/utils/constants'
import { mapGetters } from 'vuex'
import moment from 'moment'
import Utils from '@/utils'
import MaterialCard from '@/components/template/MaterialCard'
import CustomDatePicker from '@/components/template/CustomDatePicker'
import _ from 'lodash'
import AssignFeePlan from '../../Fees/FeeComponent/assignFeePlan'

export default {
  components: { MaterialCard, CustomDatePicker, AssignFeePlan },
  name: 'nodalLedger',
  data () {
    return {
      STUDENT_DATA: {},
      dialogDelete: false,
      planAssignModal: false,
      students: [],
      modal1: false,
      modal: false,
      franchiseeID: '',
      franchiseeArr: [],
      selectedClassID: '',
      headers: this.getHeaders(),
      feeAssignHeader: this.getfeeAssignHeader(),
      selectedSectionID: '',
      isLoading: false,
      classWiseSections: [],
      classes: [],
      loadingComponent: null,
      totalStudents: 0,
      academicYearID: '',
      academicYears: [],
      isWrite: false,
      promotedClassData: [],
      selectedPromotedClassID: '',
      promotedSectionData: [],
      assignfeePlanInfo: [],
      tab: 0,
      newAdmissionID: '',
      postedData: {},
      search: '',
      isCompo: '',
      selectedClassName: '',
      promotedTypeID: null,
      isRazorPayAccount: false,
      promotedStudentFranchiseeID: null,
      revokeDialog: false,
      revokeData: {}
    }
  },
  created: async function () {
    this.isWrite = Utils.helper.getIsWriteFun(this.$route)
    await this.onFranchiseeChange()
  },
  computed: {
    ...mapGetters({
      franchisee: 'getFranchisee',
      academicYear: 'getAcademicYear'
    })
  },

  watch: {
    tab: async function (val) {
      this.students = []
      this.assignfeePlanInfo = []
      await this.onFranchiseeChange()
    },
    planAssignModal: async function (val) {
      if (!val) {
        await this.getPromotedStudentList()
      }
    },
    franchisee: async function (val) {
      this.students = []
      await this.onFranchiseeChange()
    },
    academicYear: async function (val) {
      this.students = []
      await this.onFranchiseeChange()
    }
  },
  methods: {
    getDisabled (item) {
      if (item.studentPromoteStatus) {
        return true
      }
      if (
        Number(item.studentEnrollment.amountDue) > 0 ||
        (item &&
          item.studentPromoteStatus &&
          item.studentPromoteStatus.newStudentAdmissionsID) ||
        !!(
          item &&
          item.studentPromoteStatus &&
          item.studentPromoteStatus.promotedTypeID === 3
        )
      ) {
        return true
      }
      if (
        Number(item.studentEnrollment.amountDue) > 0 ||
        !!(
          item &&
          item.studentPromoteStatus &&
          item.studentPromoteStatus.newStudentAdmissionsID
        ) ||
        !!(
          item &&
          item.studentPromoteStatus &&
          item.studentPromoteStatus.promotedTypeID === 3
        )
      ) {
        return true
      }
      if (
        Number(item.studentEnrollment.amountDue) > 0 ||
        Number(item.studentEnrollment.amountRoyaltyDue) > 0
      ) {
        return true
      }
      if (
        Number(item.studentEnrollment.amountDue) > 0 ||
        !!(
          item &&
          item.studentPromoteStatus &&
          item.studentPromoteStatus.newStudentAdmissionsID
        )
      ) {
        return true
      }
    },
    payNow: async function (item) {
      try {
        this.isLoading = true
        let { data } = await http.post(
          `${constants.API_URL}/api/student/promotion-link`,
          {
            admissionID: item.newStudentAdmission.id,
            mode: 'OFFLINE'
          }
        )

        this.isLoading = false
        this.$router.push({
          name: 'admissionFormOffline',
          params: { referenceID: data }
        })
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
        console.log('errorMessage', errorMessage)
        return this.$dialog.error({
          text: ` ${errorMessage}`,
          title: 'Error'
        })
      } finally {
        this.isLoading = false
      }
    },
    itemRowBackground: function (item) {
      return Number(item.studentEnrollment.amountDue) ||
        Number(item.studentEnrollment.amountRoyaltyDue) > 0 ||
        item.studentPromoteStatus
        ? 'style-1'
        : 'style-2'
    },
    sendLink: async function (item, isOffline = false) {
      try {
        this.isLoading = true
        const response = await http.post(
          `${constants.API_URL}/api/student/promotion-link`,
          {
            admissionID: item.newStudentAdmission.id,
            mode: isOffline ? 'OFFLINE' : 'ONLINE'
          }
        )
        if (isOffline) {
          // this.$router.push({ name: 'OfflinePayments', params: { referenceID: response.data } })

          let route = this.$router.resolve({
            name: 'OfflinePayments',
            params: { referenceID: response.data }
          })
          // let route = this.$router.resolve('/link/to/page'); // This also works.
          window.open(route.href, '_blank')
        } else {
          return this.$dialog.info({
            text: `Payment Link Sent on Mail`,
            title: 'Success'
          })
        }
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
        console.log('errorMessage', errorMessage)
        return this.$dialog.error({
          text: ` ${errorMessage}`,
          title: 'Error'
        })
      } finally {
        this.isLoading = false
      }
    },

    givenOkay: async function () {
      try {
        let CurrentYearpayload = {
          academicYearID: this.academicYearID,
          isNextAcademicYear: true
        }
        let nextAcadmicYearID = ''
        this.isLoading = true
        if (
          !(
            this.postedData.selectedInfo.promotedTypeID === 3 ||
            this.postedData.selectedInfo.promotedTypeID === 4
          )
        ) {
          nextAcadmicYearID = await http.get(
            `${constants.API_URL}/api/franchiseeAcademicYears-by-id`,
            { params: CurrentYearpayload }
          )
        }
        this.isLoading = false
        this.isLoading = true
        let payLoad = {
          franchiseeID: this.franchiseeID,
          academicYearID: this.academicYearID,
          classID: this.selectedClassID,
          sectionID: this.selectedSectionID,

          studentData: [
            {
              oldStudentAdmissionsID: this.postedData.id,

              promotedTypeID: this.postedData.selectedInfo.promotedTypeID,
              // "status":"PROMOTED"
              // "assignFeeComponentActivesID":"",

              promotedDate: moment().format('YYYY-MM-DD'), // optional
              isActive: true
            }
          ]
        }
        if (
          !(
            this.postedData.selectedInfo.promotedTypeID === 3 ||
            this.postedData.selectedInfo.promotedTypeID === 4
          )
        ) {
          payLoad.promotingAcademicYearID =
            nextAcadmicYearID &&
            nextAcadmicYearID.data[0] &&
            nextAcadmicYearID.data[0].id
              ? nextAcadmicYearID.data[0].id
              : '' // optional
        }
        if (this.postedData.selectedInfo.selectedClass) {
          payLoad.studentData[0].promotingClassID =
            this.postedData.selectedInfo.selectedClass
        }
        if (this.postedData.selectedInfo.selectedSection) {
          payLoad.studentData[0].promotingSectionID =
            this.postedData.selectedInfo.selectedSection
        }
        if (
          this.postedData.selectedInfo.expectedDate &&
          this.postedData.selectedInfo.promotedTypeID !== 3
        ) {
          payLoad.studentData[0].date =
            this.postedData.selectedInfo.expectedDate
        }
        console.log('payLoad--', payLoad)

        await http.post(`${constants.API_URL}/api/student/promotion`, payLoad)
        this.dialogDelete = false

        this.$nextTick(() => {
          this.selectedClassID = ''
          this.selectedSectionID = ''
          this.students = []
        })
        this.isLoading = false
        // await this.onFranchiseeChange()
        return this.$dialog.info({
          text: `Details Saved Successfully`,
          title: 'Success'
        })
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.dialogDelete = false
        console.log('errorMessage', errorMessage)
        return this.$dialog.error({
          text: ` ${errorMessage}`,
          title: 'Error'
        })
      } finally {
        this.isLoading = false
      }
    },
    assignFee: function (newAdmissionID) {
      this.isCompo = ''
      this.$nextTick(() => {
        this.isCompo = AssignFeePlan
      })
      this.STUDENT_DATA = newAdmissionID
      this.newAdmissionID = newAdmissionID.newStudentAdmission.id
    },
    getPromotedByType: async function (item) {
      item.selectedSectionMap = []
      item.selectedInfo.selectedClass = ''
      if (
        item.selectedInfo.promotedTypeID === 2 ||
        item.selectedInfo.promotedTypeID === 1 ||
        item.selectedInfo.promotedTypeID === 5 ||
        item.selectedInfo.promotedTypeID === ''
      ) {
        // isNextClass will be false only if selected option is DETAINED_PROMOTED
        let classSection = await http.get(
          `${constants.API_URL}/api/student/next/class-section`,
          {
            params: {
              classID: item.classID,
              isNextClass: item.selectedInfo.promotedTypeID !== 2
            }
          }
        )
        // item.classSectionMaps = classSection.data
        // only Hybrid classes will appear while promoting student
        item.classSectionMaps = classSection.data.filter((map) => {
          return map.category === 'Hybrid'
        })

        item.selectedInfo.selectedClass = ''
        item.selectedInfo.selectedClass = item.studentClass.id

        let sectionarray = this.sections.find(
          (obj) => obj.id === item.selectedInfo.selectedClass
        )
        if (sectionarray) {
          item.selectedSectionMap = sectionarray.sections
        } else {
          item.selectedSectionMap = []
        }
      }
    },
    // getPromotedByType: function (item) {
    //   item.selectedSectionMap = []
    //   item.selectedInfo.selectedClass = ''

    //   if (item.selectedInfo.promotedTypeID === 2) {
    //     item.selectedInfo.selectedClass = ''
    //     item.selectedInfo.selectedClass = item.studentClass.id
    //     let sectionarray = this.sections.find(obj => obj.id === item.selectedInfo.selectedClass)
    //     if (sectionarray) {
    //       item.selectedSectionMap = sectionarray.sections
    //     } else {
    //       item.selectedSectionMap = []
    //     }
    //   }
    // },
    promoteStudent: async function (item) {
      this.selectedClassName = item.classSectionMaps.find(
        (x) => x.id === item.selectedInfo.selectedClass
      )
      if (!item.selectedInfo.promotedTypeID) {
        return this.$dialog.error({
          text: ` Field cannot be blank`,
          title: 'Error'
        })
      }
      this.promotedTypeID = item.selectedInfo.promotedTypeID
      if (
        item.selectedInfo.promotedTypeID === 5 ||
        item.selectedInfo.promotedTypeID === 2 ||
        item.selectedInfo.promotedTypeID === 1
      ) {
        if (
          !(
            item.selectedInfo.selectedClass && item.selectedInfo.selectedSection
          )
        ) {
          return this.$dialog.error({
            text: ` Class Or section Cannot be blank`,
            title: 'Error'
          })
        }
      }
      this.dialogDelete = true
      this.postedData = Object.assign({}, item)
    },
    getPromotedSection: function (item) {
      try {
        let sectionInfo = _.filter(item.classSectionMaps, (obj) => {
          return obj.id === item.selectedInfo.selectedClass
        })
        if (!_.isEmpty(sectionInfo)) {
          item.selectedSectionMap = sectionInfo[0].studentSections
        }
      } catch (e) {
        return this.$dialog.error({
          text: ` ${e}`,
          title: 'Error'
        })
      }
    },
    getHeaders () {
      let header = [
        {
          text: 'Name ',
          value: 'studentEnrollment.studentName',
          align: 'center'
        },
        {
          text: 'Enrollment Code',
          value: 'studentEnrollment.enrollmentCode',
          align: 'center'
        },
        {
          text: 'Enrollment MCB',
          value: 'studentEnrollment.enrollmentNoMCB',
          align: 'center'
        },
        { text: 'Current Class ', value: 'studentClass.name', align: 'center' },
        {
          text: 'Current Year',
          value: 'franchiseeAcademicYear.academicYear',
          align: 'center'
        },
        { text: 'Promoted Type', value: 'promotedType', align: 'center' },
        { text: 'Promoted Class To', value: 'promotedClass', align: 'center' },
        {
          text: 'Promoted Section To',
          value: 'promotedSection',
          align: 'center'
        },

        { text: ' Expected Date', value: 'date', align: 'center' },
        { text: ' Action/Comment', value: 'action', align: 'center' }
      ]

      // header.push({ text: '', value: 'data-table-expand' })
      return header
    },
    getfeeAssignHeader () {
      let assignFeeHeader = [
        { text: 'Name ', value: 'studentName', align: 'center' },
        { text: 'Enrollment Code', value: 'studentEnrollment', align: 'center' },
        { text: 'Status', value: 'studentPromoteType.name', align: 'center' },
        { text: 'Promoted Class', value: 'class', align: 'center' },
        { text: 'Promoted Section', value: 'section', align: 'center' },
        {
          text: 'Previous Class',
          value: 'oldStudentAdmission.class',
          align: 'center'
        },
        {
          text: 'Previous Section',
          value: 'oldStudentAdmission.section',
          align: 'center'
        },
        { text: 'Promoted Academic Year', value: 'year', align: 'center' },
        { text: 'Promoted Date', value: 'promotedDate', align: 'center' },
        { text: 'Actions', value: 'action', align: 'center' }
      ]
      return assignFeeHeader
    },
    onFranchiseeChange: async function () {
      if (!this.inProgress) {
        this.inProgress = true
        if (this.franchisee) {
          this.franchiseeID = this.franchisee.id
        } else {
          this.franchiseeID = ''
        }
        if (this.academicYear) {
          this.academicYearID = this.academicYear.id
        } else {
          this.academicYearID = ''
        }
        this.selectedClassID = ''
        this.selectedSectionID = ''
        this.classes = []
        if (this.franchiseeID) {
          if (this.tab === 0) {
            await this.getClassList()

            await this.getStudents(this.franchiseeID)
          }
          if (this.tab === 1) {
            await this.getClassList()

            await this.getPromotedStudentList(this.franchiseeID)
          }
        }
        this.inProgress = false
      }
    },
    getPromotedStudentList: async function (franchisseID) {
      try {
        this.isLoading = true

        let formData = {
          franchiseeID: this.franchiseeID
        }
        if (this.selectedSectionID) {
          formData.sectionID = this.selectedSectionID
        }
        if (this.academicYearID) {
          formData.academicYearID = this.academicYearID
        }
        if (this.selectedClassID) {
          formData.classID = this.selectedClassID
        }

        let response = await http.get(
          `${constants.API_URL}/api/student/promoted-student`,
          { params: formData }
        )

        this.assignfeePlanInfo = response.data
        this.assignfeePlanInfo.forEach((item) => {
          this.promotedStudentFranchiseeID = item.franchiseeID
        })
        _.forEach(this.assignfeePlanInfo, (item) => {
          item.promotedDate = item.promotedDate
            ? moment(item.promotedDate).format('DD-MM-YYYY')
            : 'N/A'
        })

        let sectionarray = this.sections.find(
          (obj) => obj.id === this.selectedClassID
        )
        if (sectionarray) {
          this.classWiseSections = sectionarray.sections
        } else {
          this.classWiseSections = []
        }

        this.assignfeePlanInfo = this.assignfeePlanInfo.map(item => {
          const name =
            item.newStudentAdmission?.studentEnrollment?.studentName ??
            item.oldStudentAdmission?.studentEnrollment?.studentName ??
            ''
          const studentEnrollment =
            item.newStudentAdmission?.studentEnrollment?.enrollmentCode ??
            item.oldStudentAdmission?.studentEnrollment?.enrollmentCode ??
            ''
          return {
            ...item,
            studentName: name,
            studentEnrollment: studentEnrollment
          }
        })

        await this.checkFranchiseeRazorpayAccount()
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message

        console.log('errorMessage', errorMessage)

        return this.$dialog.error({
          text: ` ${errorMessage}`,
          title: 'Error'
        })
      } finally {
        this.isLoading = false
      }
      this.assignFeeHeader = this.getfeeAssignHeader()
    },
    getClassList: async function () {
      try {
        this.isLoading = true

        let response = await http.get(
          `${constants.API_URL}/api/student/all-count?franchiseeID=${this.franchiseeID}&&academicYearID=${this.academicYearID}&&isAllValue=true`
        )
        const data = response.data
        this.classes = data

        this.sections = data.map((obj) => {
          return {
            id: obj.id,
            sections: obj.studentSections
          }
        })
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
      } finally {
        this.isLoading = false
      }
    },

    getStudents: async function (fid, cid, sid, yr) {
      if (!this.franchiseeID) {
        this.students = []
        return this.$dialog.error({
          text: `Please select Franchisee !`,
          title: 'Error'
        })
      }
      if (!this.selectedClassID) {
        return this.$dialog.error({
          text: `Please select Class & Section !`,
          title: 'Error'
        })
      }
      if (!this.selectedSectionID) {
        return
      }
      if (fid) {
        let formData = {
          franchiseeID: this.franchiseeID
        }
        if (this.selectedSectionID) {
          formData.sectionID = this.selectedSectionID
        }
        if (this.academicYearID) {
          formData.academicYearID = this.academicYearID
        }
        if (this.selectedClassID) {
          formData.classID = this.selectedClassID
        }

        try {
          this.isLoading = true

          const { data } = await http.get(
            `${constants.API_URL}/api/student/promotion`,
            {
              params: formData
            }
          )
          this.students = await Promise.all(
            data.map(async (item) => {
              // Fetching the class options
              let classSection = await http.get(
                `${constants.API_URL}/api/student/next/class-section`,
                {
                  params: {
                    classID: item.classID
                  }
                }
              )
              let promotionType = await http.get(
                `${constants.API_URL}/api/student/promotion/type`
              )
              item.classSectionMaps = classSection.data
              // only Hybrid classes will appear while promoting student
              item.classSectionMaps = classSection.data.filter((map) => {
                return map.category === 'Hybrid'
              })
              // console.log('Class Options', classSection.data)
              // Adding custom option label to the promotion dropdown
              item.promotionType = promotionType.data.map((item) => {
                switch (item.name) {
                  case 'DETAINED_AND_PROMOTED':
                    item.label = 'RETAIN'
                    break
                  default:
                    item.label = item.name
                    break
                }
                return item
              })

              const nextAcadamicYear = item.franchiseeAcademicYear.academicYear
                .toString()
                .split('-')[1]
              item.selectedInfo = {
                selectedClass: '',
                selectedSection: '',
                promotedDate: moment().format('YYYY-MM-DD'),
                expectedDate: moment(`${nextAcadamicYear}/04/01`).format(
                  'YYYY-MM-DD'
                ),
                promotedTypeID: ''
              }

              if (
                item &&
                item.studentPromoteStatus &&
                item.studentPromoteStatus.newStudentAdmissionsID
              ) {
                item.selectedInfo = {
                  selectedClass: item.studentPromoteStatus.promotingClassID,
                  selectedSection: item.studentPromoteStatus.promotingSectionID,
                  promotedDate: moment(
                    item.studentPromoteStatus.promotedDate
                  ).format('YYYY-MM-DD'),
                  expectedDate: moment(item.studentPromoteStatus.date).format(
                    'YYYY-MM-DD'
                  ),
                  promotedTypeID: item.studentPromoteStatus.promotedTypeID
                }
                classSection = await http.get(
                  `${constants.API_URL}/api/student/next/class-section`,
                  {
                    params: {
                      classID: item.classID,
                      isNextClass: item.selectedInfo.promotedTypeID !== 2
                    }
                  }
                )
                // item.classSectionMaps = classSection.data
                // only Hybrid classes will appear while promoting student
                item.classSectionMaps = classSection.data.filter((map) => {
                  return map.category === 'Hybrid'
                })
                console.log(
                  item.classSectionMaps
                    .map((row) => {
                      return row.id
                    })
                    .indexOf(item.studentPromoteStatus.promotingClassID)
                )

                await this.getPromotedSection(item)
              }

              if (
                item &&
                item.studentPromoteStatus &&
                item.studentPromoteStatus.promotedTypeID === 3
              ) {
                item.selectedInfo = {
                  promotedTypeID: item.studentPromoteStatus.promotedTypeID
                }
                console.log(
                  item.studentPromoteStatus.promotedTypeID,
                  'PId',
                  item.studentPromoteStatus.newStudentAdmissionsID,
                  'Nid'
                )
              }
              if (item && item.studentPromoteStatus) {
                if (item.studentPromoteStatus.promotedTypeID !== 2) {
                  // This student is not retained so we need to put ALUMNI status if he is in the last class
                  if (
                    this.selectedClassID === 256 ||
                    this.selectedClassID === 888 ||
                    this.selectedClassID === 892 ||
                    this.selectedClassID === 901
                  ) {
                    item.selectedInfo = {
                      promotedTypeID: 4,
                      expectedDate: moment(`${nextAcadamicYear}/04/01`).format(
                        'YYYY-MM-DD'
                      )
                    }
                  }
                }
              } else {
                // This student is not retained so we need to put ALUMNI status if he is in the last class
                if (
                  this.selectedClassID === 256 ||
                  this.selectedClassID === 888 ||
                  this.selectedClassID === 892 ||
                  this.selectedClassID === 901
                ) {
                  item.selectedInfo = {
                    promotedTypeID: 4,
                    expectedDate: moment(`${nextAcadamicYear}/04/01`).format(
                      'YYYY-MM-DD'
                    )
                  }
                }
              }

              return item
            })
          ).then((val) => {
            return val
          })

          let x = this.students.map((a) => {
            a.studentEnrollment.dateOfBirth = moment(
              a.studentEnrollment.dateOfBirth,
              'YYYY-MM-DD'
            ).format('YYYY-MM-DD')
            return a
          })
          this.students = x

          this.totalStudents = data.length
          // this.loadingComponent.close()
        } catch (e) {
          // this.loadingComponent.close()
          console.log('error in student api', e)

          return this.$dialog.error({
            text: ` ${e}`,
            title: 'Error'
          })
        } finally {
          this.isLoading = false
        }
      } else {
        // this.loadingComponent.close()
        this.students = []
      }
      this.headers = this.getHeaders()
    },
    changeSections: async function () {
      console.log('trigger')
      try {
        if (this.selectedClassID) {
          await this.getStudents(this.franchiseeID)
        }

        this.isLoading = true

        let sectionarray = this.sections.find(
          (obj) => obj.id === this.selectedClassID
        )
        if (sectionarray) {
          this.classWiseSections = sectionarray.sections
        } else {
          this.classWiseSections = []
        }
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)

        return this.$dialog.error({
          text: ` ${errorMessage}`,
          title: 'Error'
        })
      } finally {
        this.isLoading = false
      }
    },
    errMsg (msg) {
      return this.$buefy.dialog.alert({
        message: msg,
        type: 'is-danger',
        hasIcon: true,
        animation: 'zoom-out',
        size: 'is-medium',
        icon: ' mdi-exclamation',
        iconPack: 'mdi',
        ariaRole: 'alertdialog',
        ariaModal: true
      })
    },
    checkFranchiseeRazorpayAccount: async function () {
      try {
        const Data = await http.get(
          `${constants.API_URL}/api/franchisee/${this.promotedStudentFranchiseeID}`
        )
        let getRazorPayAccount = Data.data
        if (!getRazorPayAccount.razorPayAccountID) {
          this.isRazorPayAccount = true
        }
      } catch (error) {
        console.log(error)
      }
    },
    assignOrder: async function (item) {
      this.$buefy.dialog.confirm({
        message: 'Do you want to Assign Orders?',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: async function () {
          try {
            this.loadingComponent = this.$buefy.loading.open()
            let response = await http.post(
              `${constants.API_URL}/api/assign-orders`,
              { admissionID: item }
            )
            this.loadingComponent.close()
            if (response && response.data.status === 200) {
              return this.$buefy.dialog.alert({
                type: 'is-success',
                message: response.data.message,
                hasIcon: true,
                animation: 'zoom-out',
                size: 'is-medium',
                icon: ' mdi-exclamation',
                iconPack: 'mdi',
                ariaRole: 'alertdialog',
                ariaModal: true
              })
            } else {
              const errorMessage = response.data.message
              this.enableUniformModal = false
              console.log('error in : ', errorMessage)
              return this.$buefy.dialog.alert({
                type: 'is-danger',
                message: errorMessage,
                hasIcon: true,
                animation: 'zoom-out',
                size: 'is-medium',
                icon: ' mdi-exclamation',
                iconPack: 'mdi',
                ariaRole: 'alertdialog',
                ariaModal: true
              })
            }
          } catch (e) {
            this.loadingComponent.close()

            const errorMessage =
              (e && e.response && e.response.data.message) || e.message
            this.enableUniformModal = false
            console.log('error in : ', errorMessage)
            return this.$buefy.dialog.alert({
              type: 'is-danger',
              message: errorMessage,
              hasIcon: true,
              animation: 'zoom-out',
              size: 'is-medium',

              icon: ' mdi-exclamation',
              iconPack: 'mdi',
              ariaRole: 'alertdialog',
              ariaModal: true
            })
          }
        }
      })
    },
    // Show "Revoke" if no fee assigned and no payment done
    showRevoke (item) {
      const promotedClass =
      item.newStudentAdmission?.class || item.oldStudentAdmission?.class || ''
      const normalizedClass = promotedClass.replace(/\s+/g, '').toLowerCase()
      if (normalizedClass === 'pp2' || normalizedClass === 'ppii') {
        return false
      }

      const currentAcademicYear = Utils.getCurrentAcademicYear()
      let previousAcademicYear = ''
      if (currentAcademicYear && currentAcademicYear.includes('-')) {
        const [start, end] = currentAcademicYear.split('-').map(Number)
        previousAcademicYear = `${start - 1}-${end - 1}`
      }
      // Revoke Drop Currret and Previous Year
      if (item.status === 'DROP' &&
      item.newStudentAdmission &&
      item.newStudentAdmission.franchiseeAcademicYear &&
      item.newStudentAdmission.franchiseeAcademicYear.academicYear === currentAcademicYear) {
        return true
      } else if (item.status === 'DROP' &&
      item.oldStudentAdmission &&
      item.oldStudentAdmission.franchiseeAcademicYear &&
      item.oldStudentAdmission.franchiseeAcademicYear.academicYear === previousAcademicYear) {
        return true
      } else if (item.status === 'DROP') {
        return false
      }

      // Revoke Alumni Current and Previous Year
      if (item.status === 'ALUMNI' &&
      item.newStudentAdmission &&
      item.newStudentAdmission.franchiseeAcademicYear &&
      item.newStudentAdmission.franchiseeAcademicYear.academicYear === currentAcademicYear) {
        return true
      } else if (item.status === 'ALUMNI' &&
      item.oldStudentAdmission &&
      item.oldStudentAdmission.franchiseeAcademicYear &&
      item.oldStudentAdmission.franchiseeAcademicYear.academicYear === previousAcademicYear) {
        return true
      } else if (item.status === 'ALUMNI') {
        return false
      }

      // const feeAssigned = !!item.assignFeeComponentActivesID
      // const paymentDone = !!item.paymentStatus && ['paid', 'partially_paid'].includes(item.paymentStatus.toLowerCase())
      // return !feeAssigned && !paymentDone

      const feeAssigned = !!item.assignFeeComponentActivesID
      const paymentDone = item.installmentpaid

      // If fee is assigned and payment is NOT done, show revoke (return true)
      if (feeAssigned && !paymentDone) {
        return true
      }

      // If only fee is assigned (regardless of payment), show revoke
      if (!feeAssigned) {
        return true
      }

      // Otherwise, do not show revoke
      return false
    },
    openRevokeDialog (item) {
      this.revokeData = {
        oldClass: item.oldStudentAdmission?.class || '-',
        newClass: item.newStudentAdmission?.class || '-',
        admissionId: item.newStudentAdmission?.id || item.oldStudentAdmission?.id,
        enrollmentCode: item.newStudentAdmission?.studentEnrollment?.enrollmentCode ||
          item.oldStudentAdmission?.studentEnrollment?.enrollmentCode || '-'
      }
      this.revokeDialog = true
    },
    async revokePromotion (data) {
      try {
        // Replace with your API for revoking promotion
        await http.post(
          `${constants.API_URL}/api/student/revoke-promoted`,
          {
            enrollmentCode: data.enrollmentCode,
            academicYearID: this.academicYearID
          }
        )
        this.revokeDialog = false
        this.$dialog.info({
          text: 'Promotion has been revoked.',
          title: 'Success'
        })
        this.getPromotedStudentList()
      } catch (e) {
        this.revokeDialog = false
        this.$dialog.error({
          text: `Error revoking promotion: ${(e && e.response && e.response.data.message) || e.message}`,
          title: 'Error'
        })
      }
    }
  }
}
</script>
<style>
.style-1 {
  background-color: #ffcdd2;
}
.style-2 {
  background-color: #e0f2f1;
}
.warning-text {
  font-size: 14px;
}
@media screen and (max-width: 600px) {
  .style-1 > td {
    background-color: #ffcdd2;
  }
  .style-2 > td {
    background-color: #e0f2f1;
  }
}

.fontBold {
  font-weight: 500;
}
</style>
